export function childrenFunc(children, val) {
    if (typeof children === 'function') {
        return children?.(val);
    }
    else {
        return children;
    }
}
